import React, { useEffect, useRef } from "react";
import "./index.css";

import Overlay from "../Overlay";

export default ({
    show,
    title,
    description,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    destructive = false,
    busy = false,
    onConfirm,
    onCancel,
}) => {

    const confirmRef = useRef(null);

    useEffect(() => {
        if (!show) return;
        const onKey = (e) => {
            if (e.key === "Escape" && onCancel) onCancel();
            if (e.key === "Enter" && onConfirm && !busy) onConfirm();
        };
        window.addEventListener("keydown", onKey);
        if (confirmRef.current) confirmRef.current.focus();
        return () => window.removeEventListener("keydown", onKey);
    }, [show, busy, onCancel, onConfirm]);

    if (!show) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && onCancel) onCancel();
    };

    return (
        <Overlay>
            <div className="confirm-modal-positioner" onClick={handleBackdropClick}>
                <div className="confirm-modal" role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title">
                    <h2 className="confirm-modal-title" id="confirm-modal-title">{title}</h2>
                    {description && <p className="confirm-modal-body">{description}</p>}
                    <div className="confirm-modal-actions">
                        <button
                            type="button"
                            className="confirm-modal-button confirm-modal-button--secondary"
                            onClick={onCancel}
                            disabled={busy}
                        >
                            {cancelLabel}
                        </button>
                        <button
                            ref={confirmRef}
                            type="button"
                            className={`confirm-modal-button ${destructive ? "confirm-modal-button--destructive" : "confirm-modal-button--primary"}`}
                            onClick={onConfirm}
                            disabled={busy}
                        >
                            {confirmLabel}
                        </button>
                    </div>
                </div>
            </div>
        </Overlay>
    );

}
